/* ln-recently-viewed.js — Lilla Napoli (Fas 1)
   1) Records the product IDs a visitor views (localStorage, most-recent-first).
   2) On the product page, powers the "Recommended / Recently viewed" toggle
      under the bottom slider. The recently-viewed grid is fetched on demand
      via the Section Rendering API (/search?q=id:… &sections=recently-viewed)
      and reordered to match recency.
   Reversible: delete this file + its <script> in layout/theme.liquid and the
   toggle markup in sections/product-recommendations.liquid. */
(function () {
  var KEY = 'ln-recently-viewed';
  var MAX = 12;

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function write(a) {
    try {
      localStorage.setItem(KEY, JSON.stringify(a));
    } catch (e) {}
  }

  var container = document.querySelector('.ln-product-sliders');
  var currentId = container && container.getAttribute('data-current-id');

  // 1) Track the current product (runs on every product page that shows the
  //    recommendations section).
  if (currentId) {
    var list = read().filter(function (id) {
      return String(id) !== String(currentId);
    });
    list.unshift(String(currentId));
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
  }

  if (!container) return; // no toggle on this page

  // 2) Toggle behaviour
  var buttons = container.querySelectorAll('.ln-slider-toggle__btn');
  var panels = container.querySelectorAll('.ln-slider-panel');
  var rvLoaded = false;

  function activate(name) {
    buttons.forEach(function (b) {
      var on = b.getAttribute('data-panel') === name;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== name;
    });
    if (name === 'recently' && !rvLoaded) {
      rvLoaded = true;
      loadRecentlyViewed();
    }
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      activate(b.getAttribute('data-panel'));
    });
  });

  // 3) Load the recently-viewed grid on demand
  function loadRecentlyViewed() {
    var grid = container.querySelector('.ln-rv-grid');
    if (!grid) return;
    var ids = read().filter(function (id) {
      return String(id) !== String(currentId);
    });
    if (!ids.length) {
      grid.innerHTML =
        '<p class="ln-rv-empty">No recently viewed products yet.</p>';
      return;
    }
    var q = ids
      .map(function (id) {
        return 'id:' + id;
      })
      .join(' OR ');
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    var url =
      root +
      'search?type=product&options[unavailable_products]=last&q=' +
      encodeURIComponent(q) +
      '&sections=recently-viewed';

    grid.classList.add('ln-rv-loading');
    fetch(url, { cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        grid.innerHTML = data['recently-viewed'] || '';
        reorder(grid, ids);
        grid.classList.remove('ln-rv-loading');
      })
      .catch(function () {
        grid.innerHTML =
          '<p class="ln-rv-empty">Could not load recently viewed.</p>';
        grid.classList.remove('ln-rv-loading');
      });
  }

  // Search ignores our id order, so re-append cards in recency order.
  function reorder(grid, ids) {
    var ul = grid.querySelector('ul');
    if (!ul) return;
    var byId = {};
    Array.prototype.forEach.call(ul.querySelectorAll('[data-rv-id]'), function (
      li
    ) {
      byId[li.getAttribute('data-rv-id')] = li;
    });
    ids.forEach(function (id) {
      if (byId[id]) ul.appendChild(byId[id]);
    });
  }
})();
